<template>
    <div class="cart-table__row">
        <div class="cart-table__mobile-visible cart-table__mobile-titles">
            <p class="cart-table__outlet" v-if="item.outlet">Уцененный товар</p>
            <p>{{item.status}}</p>
            <p class="cart-table__product-name">
                <a class="cart-table__product-text-link" :href="item.url">{{ item.name }}</a>
            </p>

            <p class="cart-table__product-desc">
                <a class="cart-table__product-text-link" :href="item.url">{{ item.previewText }}</a>
            </p>
        </div>

        <div class="cart-table__pic-wrapper">
            <a class="cart-table__pic-link" :href="item.url">
                <picture class="picture cart-table__pic">
                    <source
                            type="image/webp"
                            data-sizes="auto"
                            :data-srcset="`${item.webpImage} 87w`"
                            sizes="56px"
                            :srcset="`${item.webpImage} 87w`"
                    />
                    <img
                            data-sizes="auto"
                            :data-srcset="`${item.jpegImage} 87w`"
                            :src="`${item.jpegImage}`"
                            :srcset="`${item.jpegImage} 87w`"
                            class="picture__img lazyautosizes lazyloaded"
                            alt
                            sizes="56px"
                    />
                </picture>
            </a>
        </div>
        <div class="cart-table__main">
            <div class="cart-table__info">
                <div class="cart-table__mobile-hidden">
                    <p class="cart-table__outlet" v-if="item.outlet">Уцененный товар</p>
                  <p>{{item.status}}</p>
                </div>

                <p class="cart-table__product-name cart-table__mobile-hidden">
                    <a class="cart-table__product-text-link" :href="item.url">
                        <span class="cart-table__product-text-brand">{{item.brand}}</span>
                        <span class="cart-table__product-text-desc">{{item.name}}</span>
                    </a>
                </p>

                <p class="cart-table__product-desc cart-table__mobile-hidden">
                    <a class="cart-table__product-text-link" :href="item.url">{{item.desc}}</a>
                </p>

                <div class="cart-table__prop">
                    <span
                            class="cart-table__mobile-caption cart-table__mobile-caption--desktop-visible"
                    >Объём</span>
                    <span class="cart-table__prop-value">{{item.measure }}</span>

                    <button
                            v-if="!readOnly"
                            class="js-cart-prop-change link cart-table__prop-change"
                            type="button"
                            data-quick-view-popup="#popup-quick-view-checkout"
                            :data-variant-id="item.id"
                            :data-outlet="item.outlet"
                    >Изменить</button>
                </div>
            </div>

            <div class="cart-table__amount">
                <span class="cart-table__mobile-caption">Кол-во</span>

                <template v-if="readOnly">{{qnt}}</template>
                <template v-else>
                    <div class="spinner spinner--product-amount-1 cart-table__spinner">
                        <button
                                class="spinner__btn spinner__btn--dec"
                                type="button"
                                v-on:click="qnt--"
                        >
                            <svg class="icon icon--minus spinner__icon">
                                <title>Уменьшить</title>
                                <use xlink:href="#icon-minus" />
                            </svg>
                        </button>
                        <label
                                class="spinner__label is-hidden"
                                for="spinner-product-amount-1-input"
                        >Значение:</label>
                        <input
                                type="number"
                                class="spinner__input js-product-count"
                                name="spinner-product-amount-1-input"
                                id="spinner-product-amount-1-input"
                                v-model.lazy="qnt"
                                min="0"
                                max="999"
                        />
                        <button
                                class="spinner__btn spinner__btn--inc"
                                type="button"
                                v-on:click="qnt++"
                        >
                            <svg class="icon icon--plus spinner__icon">
                                <title>Увеличить</title>
                                <use xlink:href="#icon-plus" />
                            </svg>
                        </button>
                    </div>
                </template>
            </div>

            <div class="cart-table__price">
                <span class="cart-table__mobile-caption">Цена</span>
                <p class="cart-table__product-price-old" v-if="item.isDiscount">
                    <span
                            class="cart-table__product-price-old-line"
                            :inner-html.prop="item.discount|price"
                    ></span>
                </p>

                <p class="cart-table__product-price" :inner-html.prop="item.basePrice|price"></p>
            </div>

            <div class="cart-table__sum">
                <span class="cart-table__mobile-caption">Сумма</span>
                <span :inner-html.prop="item.finalPrice|price"></span>
            </div>
        </div>

        <button
                v-if="!readOnly"
                class="cart-table__remove"
                type="button"
                title="Удалить"
                v-on:click="removeBasketItem({ itemId: item.id, outlet: item.outlet })"
        >
            <svg class="icon icon--close_sm">
                <use xlink:href="#icon-close_sm" />
            </svg>
        </button>
    </div>
</template>

<script>
    import Spinner from '../../../components/base/Spinner';
    import initPopupQuickView from './../quickView';
    import { mapState, mapGetters, mapActions } from 'vuex';

    function checkDecrement() {}

    export default {
        name: 'basket-item',
        props: {
            item: {},
            readOnly: Boolean,
        },
        mounted() {
            initPopupQuickView();

            let $dec = $(this.$vnode.elm).find('.spinner__btn--dec');
            let value = this.item.qnt;
            let countResult = value == 1 ? $dec.prop('disabled', true) : $dec.prop('disabled', false);
            return countResult;
        },
        methods: {
            ...mapActions(['removeBasketItem', 'changeQntBasketItem']),
        },
        computed: {
            qnt: {
                get() {
                    return this.item.qnt;
                },
                set(value) {
                    if (value < 1) {
                        return;
                    }

                    this.item.qnt = value; //Это что бы сразу менялось в интерфейсе
                    this.changeQntBasketItem({
                        itemId: this.item.id,
                        count: value,
                        outlet: this.item.outlet,
                    });

                    let $dec = $(this.$vnode.elm).find('.spinner__btn--dec');
                    let countResult = value == 1 ? $dec.prop('disabled', true) : $dec.prop('disabled', false);
                    return countResult;
                },
            },
        },
    };
</script>
